export const quiniela = {
  quinielaTitle: "Quiniela",
  quinielaHeroTitle: "Quiniela Mundialista",
  quinielaSubtitle: "Mundial FIFA 2026",
  quinielaDescription: "Predice los resultados de los partidos del Mundial y gana premios",
  quinielaPremiumLabel: "Boleto mundialista",
  quinielaMiniBanner: "Giro mundialista",
  quinielaBalance: "Saldo",
  quinielaActiveRound: "Jornada activa",
  quinielaMatches: "Partidos",
  quinielaRounds: "Jornadas",
  quinielaLeaderboard: "Posiciones",
  quinielaMyPredictions: "Mis Predicciones",
  quinielaMyTickets: "Mis boletos",
  quinielaPlayTab: "Pronosticar",
  quinielaTicketTab: "Mi boleto",
  quinielaRulesTab: "Reglas",
  quinielaRulesTabHint: "Guía rápida",
  quinielaTabsNav: "Navegación principal de quiniela",
  quinielaHowToPlayCta: "Cómo jugar",
  quinielaChooseTournament: "Elige torneo",
  quinielaChooseRound: "Elige jornada",
  quinielaPlayNow: "Jugar ahora",
  quinielaViewTicket: "Ver mi boleto",
  quinielaReviewTicket: "Revisar boleto",
  quinielaReviewEyebrow: "Revisión",
  quinielaConfirmBet: "Confirmar apuesta",
  quinielaEditPicks: "Editar picks",
  quinielaSubmit: "Enviar Predicciones",
  quinielaSubmitSuccess: "Predicciones enviadas correctamente",
  quinielaSubmitError: "Error al enviar predicciones",
  quinielaLoadError: "No pudimos cargar los partidos de esta jornada.",
  quinielaRetry: "Reintentar",
  quinielaTicketConfirmed: "Boleto confirmado.",
  quinielaTicketConfirmedTitle: "Boleto confirmado",
  quinielaTicketId: "ID de boleto",
  quinielaTicketIdPending: "Generándose",
  quinielaConfirmedAt: "Confirmado",
  quinielaDeadline: "Cierre de predicciones",
  quinielaEntryFee: "Costo de entrada",
  quinielaPrizePool: "Pozo de premios",
  quinielaCurrentBalance: "Saldo actual",
  quinielaBalanceAfter: "Saldo después",
  quinielaPoints: "Puntos",
  quinielaRank: "Posición",
  quinielaHomeWin: "Local",
  quinielaDraw: "Empate",
  quinielaAwayWin: "Visitante",
  quinielaMatchDay: "Jornada",
  quinielaGroup: "Grupo",
  quinielaGroupStage: "Fase de Grupos",
  quinielaRound32: "Dieciseisavos de Final",
  quinielaRound16: "Octavos de Final",
  quinielaQuarterFinals: "Cuartos de Final",
  quinielaSemiFinals: "Semifinales",
  quinielaThirdPlace: "Tercer Puesto",
  quinielaFinal: "Final",
  quinielaVs: "vs",
  quinielaPenalties: "pen",
  quinielaPrediction: "Predicción",
  quinielaResult: "Resultado",
  quinielaCorrect: "Correcto",
  quinielaIncorrect: "Incorrecto",
  quinielaPending: "Pendiente",
  quinielaRoundOpen: "Abierta",
  quinielaRoundLocked: "Cerrada",
  quinielaRoundScored: "Calificada",
  quinielaRoundUpcoming: "Próximamente",
  quinielaRoundClosedTitle: "Esta jornada ya está cerrada.",
  quinielaRoundClosedDescription: "No puedes editar ni enviar picks porque la jornada ya cerró.",
  quinielaNoRounds: "No hay jornadas disponibles",
  quinielaNoTicketYet: "Todavía no tienes un boleto cargado.",
  quinielaNoTicketDescription: "Completa tus picks 1X2 y revisa tu boleto antes de confirmar.",
  quinielaStartTicket: "Comenzar boleto",
  quinielaAlreadySubmitted: "Ya enviaste tus predicciones para esta jornada",
  quinielaSelectAll: "Debes seleccionar una predicción para cada partido",
  quinielaMissingPicks: "Te faltan {{count}} partidos por completar.",
  quinielaMissingPicksShort: "Te faltan {{count}} picks",
  quinielaTabReady: "Listo para enviar",
  quinielaTabWaiting: "Sin jornada activa",
  quinielaTabLocked: "Picks bloqueados",
  quinielaTabPendingCount: "{{count}} pendientes",
  quinielaTabTicketDraft: "Borrador",
  quinielaTabTicketEmpty: "Vacío",
  quinielaTabTicketConfirmed: "Confirmado",
  quinielaTabLeaderboardLive: "Competencia en curso",
  quinielaTabLeaderboardReady: "Resultados listos",
  quinielaTournamentLeaderboard: "Clasificación General",
  quinielaRoundLeaderboard: "Clasificación de la Jornada",
  quinielaFree: "Gratis",
  quinielaUser: "Usuario",
  quinielaTotalPoints: "Puntos Totales",
  quinielaMyPosition: "Mi posición",
  quinielaYourPick: "Tu pick",
  quinielaPredictionsLocked: "Predicciones bloqueadas.",
  quinielaInsufficientBalanceTitle: "Saldo insuficiente.",
  quinielaInsufficientBalanceDescription: "Necesitas más saldo para confirmar este boleto.",

  quinielaHowToPlayTitle: "¿Cómo jugar la Quiniela?",
  quinielaHowToPlayStep1Title: "1. Elige una jornada",
  quinielaHowToPlayStep1Desc:
    "Selecciona la jornada abierta del Mundial FIFA 2026. Cada jornada agrupa varios partidos que se juegan en el mismo día.",
  quinielaHowToPlayStep2Title: "2. Predice los resultados",
  quinielaHowToPlayStep2Desc:
    "Para cada partido, selecciona: 1 (gana el local), X (empate) o 2 (gana el visitante). Debes completar todos los partidos de la jornada.",
  quinielaHowToPlayStep3Title: "3. Paga y confirma",
  quinielaHowToPlayStep3Desc:
    "Si la jornada tiene costo de entrada, se debitará de tu saldo de juego al enviar tus predicciones. Las predicciones no se pueden cambiar después de enviarlas.",
  quinielaHowToPlayStep4Title: "4. Gana puntos",
  quinielaHowToPlayStep4Desc:
    "Cada predicción correcta vale 1 punto. Al finalizar todos los partidos de la jornada, se calculan los puntos automáticamente.",
  quinielaHowToPlayStep5Title: "5. Revisa la clasificación",
  quinielaHowToPlayStep5Desc:
    "Consulta la tabla de clasificación de la jornada y la clasificación general del torneo. ¡Los mejores predictores ganan premios del pozo!",
  quinielaHowToPlayNote:
    "Las predicciones se cierran antes del inicio del primer partido de cada jornada. Asegúrate de enviar tus predicciones a tiempo.",
};
